import { createContext, type Dispatch, type SetStateAction, useContext } from 'react'

type SubscriptionContextValue = {
  isSubmitting: boolean
  setIsSubmitting: Dispatch<SetStateAction<boolean>>

  isSubscriptionInProgress: boolean
  setIsSubscriptionInProgress: (inProgress: boolean) => void
  // Returns false if a subscription request is already in flight, so a second click can't create a duplicate
  tryStartSubscription: () => boolean

  planFormValid: boolean
  setPlanFormValid: Dispatch<SetStateAction<boolean>>

  billingDetailsFormValid: boolean
  setBillingDetailsFormValid: Dispatch<SetStateAction<boolean>>

  isConfirmationOpen: boolean
  setIsConfirmationOpen: Dispatch<SetStateAction<boolean>>

  inAuthStep: boolean
  setInAuthStep: Dispatch<SetStateAction<boolean>>

  msaConsent: boolean
  setMsaConsent: Dispatch<SetStateAction<boolean>>

  showMsaError: boolean
  setShowMsaError: Dispatch<SetStateAction<boolean>>

  handleMSAChange: (checked: boolean) => void
  handleSubscribeClick: () => void

  subscriptionVersion: 'v1' | 'v2'
}

const SubscriptionContext = createContext<SubscriptionContextValue | undefined>(undefined)

const useSubscriptionContext = (): SubscriptionContextValue => {
  const context = useContext(SubscriptionContext)
  if (!context) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider')
  }

  return context
}

export { SubscriptionContext, type SubscriptionContextValue, useSubscriptionContext }
